import { HttpClient } from 'shared/libs/http';
import {
    CandidateEditProfileResponse,
    CandidateEditProfileDto,
    CandidatesGetActiveCvList,
    LocalitySearchResponse,
    LocalitySearchDto,
} from './types';
import { CandidateEditProfileEmptyResponse } from './types/candidate-edit-profile-empty-response';

export class CandidateApiService {
    public static async candidatesEditProfile<TDto extends CandidateEditProfileDto | null>(
        dto: TDto
    ) {
        /**
         * Потребує уточенння
         */

        return await HttpClient.post<
            TDto extends null
                ? CandidateEditProfileEmptyResponse
                : CandidateEditProfileResponse
        >('/candidates/editProfile', dto);
    }

    public static async candidatesGetActiveCvList() {
        return await HttpClient.get<CandidatesGetActiveCvList>('/candidates/getActiveCvList');
    }

    public static async localitySearch(dto: LocalitySearchDto) {
        return await HttpClient.post<LocalitySearchResponse>('/locality/search', dto);
    }
}
